<template>
  <div class="percentage-store-expenses">
    <gj-analysis-panel
        :title="'费用利润'"
    >
      <template #subtitle>
        <span class="left-option-header-time">
          {{startDate}} ~ {{endDate}} {{dateShortcut | defaultShow('| ', '', '')}}
        </span>
      </template>
      <template #rightContainer>
        <OptionGroup
            :show-list= "['refresh']"
            @refresh="refresh"
        />
      </template>
      <template #panelBody>
        <div class="comprehensive-analysis-content">
          <gj-alert
              border
              type="warning"
              show-icon
              :style="{marginBottom: '10px'}"
          >
            按日期查询时下面数据不包含仓储费；按月份查询时下面数据包含仓储费。
          </gj-alert>
          <el-row :gutter="10">
            <el-col :span="6">
              <OptionPanelHeaderFee :loading="loading" :data="summaryData" :currencySymbol="currencySymbol"/>
            </el-col>
            <el-col :span="18">
              <el-card class="box-card" v-loading="loading">
                <Chart :type="'bar'" :option="percentageStoreExpensesOption"/>
              </el-card>
            </el-col>
          </el-row>
          <el-row :gutter="10"  v-loading="loading">
            <el-col :span="12">
              <el-card class="box-card">
                <Chart :type="'bar'" :option="percentageStoreExpensesPieOneOption"/>
              </el-card>

            </el-col>
            <el-col :span="12">
              <el-card class="box-card">
                <Chart :type="'bar'" :option="percentageStoreExpensesPieTwoOption"/>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </template>
    </gj-analysis-panel>
  </div>
</template>

<script>
import OptionPanelHeaderFee from "@/views/components/option-header/option-panel-fee"
import Chart from "@/views/components/chart/chart"
import OptionGroup from "@/views/components/option-panel-group/option-group"
import {queryMixin} from "@/minxins";
import {getFeeDetails} from "@/api/statistics"
import _ from "lodash"
import {settingMapFeeDetails} from "@/utils/setting";
import {convertToFullDate, dateShortcut} from "@/utils/date.util";
import { amount } from "@/filters";

export default {
  name: "percentage-store-expenses",
  components: { OptionPanelHeaderFee, Chart,OptionGroup},
  mixins: [queryMixin],
  inject: ['getPageParams'],
  computed: {
    startDate() {
      let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[0], dateFormat) : null;
    },
    endDate() {
       let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[1], dateFormat) : null;
    },
    dateShortcut() {
      return dateShortcut(this.filter.date.key === 0?this.filter.date.value:'');
    },
    filter () {
      return this.getPageParams()
    }
  },
  data(){
    return{
      useCache: false,
      loading: false,
      percentageStoreExpensesOption: {},
      percentageStoreExpensesPieOneOption: {},
      percentageStoreExpensesPieTwoOption: {},
      //概览数据
      summaryData: {},
      //柱状图数据
      barSuourceData:[],
      //左侧饼图数据 - 费用收入项
      incomeItemsData: [],
      //右侧饼图数据 - 费用支出项
      expensesItemsData: [],
      //左侧饼图数据 - 额外收入项
      incomeExtraItems: [],
      currencySymbol: ""
    }
  },
  mounted() {
    this.initPercentageStoreExpensesOption();
    this.initPercentageStoreExpensesPieOneOption();
    this.initPercentageStoreExpensesPieTwoOption();
    this.getFeeDetails();
  },
  methods:{
    /**
     * 获取全部初始化界面数据
     */
    $gjQuery(){
      this.getFeeDetails();

    },
    /**
     * 刷新当前模块
     */
    refresh(){
      this.$gjQuery();
    },
    /**
     * 获取费用明细
     */
    getFeeDetails(){
      this.loading = true;
      const params = {
        ...this.filter,
        countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : null,
        marketIds : this.filter.countryMarketValue ? !_.isEmpty(this.filter.countryMarketValue.marketIds) ? this.filter.countryMarketValue.marketIds: null : null,
      };
      getFeeDetails(params).then(res=>{
        let data = res;
        //顶部概览数据
        this.summaryData = _.get(data, "summaryData", {});
        //1、拼装柱状图数据  //PS 用数据集dataset/source的方式 比series/data的方式 更适合我们后端返回的数据格式，数据集 要求 echarts > 4
        let barData = _.get(data, "barData", []);
        let pieData = _.get(data, "pieData", {});
        let source = [];
        source[0] = ['marketName', '收入', '支出', '预计回款'];
        let currencySymbol = _.get(data, 'currencySymbol');
        this.currencySymbol = currencySymbol
        for(let i=0;i<barData.length;i++){
          let listItem = [];
          listItem[0] = barData[i].marketName;
          listItem[1] = barData[i].income;
          listItem[2] = barData[i].expenses;
          listItem[3] = barData[i].expectedReturn;
          source[i+1] = listItem;
        }
        this.barSuourceData = source;
        this.initPercentageStoreExpensesOption();
        //2 、拼装饼图数据
        //拼装左侧饼图数据-费用收入项
        let { incomeItems, expensesItems, incomeExtraItems } = pieData;
        this.incomeItemsData = _.map(_.concat(incomeItems,  incomeExtraItems), v=>{
          if(!v){
            v = {};
          }
          if(_.get(v, 'itemName') !== "Ads sales"){
            v.name = v.name || settingMapFeeDetails[_.get(v, 'itemName')];
            v.value = _.round(_.toNumber(_.get(v, 'fee')), 2);
            v.currencySymbol = currencySymbol;
            v.averageFee = _.round(_.toNumber(_.get(v, 'averageFee')), 2);
            v.rate =  _.round(_.get(v, 'feePercent'));
          } else {
            //额外费用 -> "广告销售额" "促销折扣"
            v.currencySymbol = currencySymbol;
            v.name = settingMapFeeDetails[_.get(v, 'itemName')];
            v.extraValue = _.round(_.toNumber(_.get(v, 'fee')), 2);
          }
          return v;
        });
        this.initPercentageStoreExpensesPieOneOption();
        //拼装右侧饼图数据-费用支出项
        this.expensesItemsData = _.map(expensesItems, v=>{
          if(!v){
            v = {};
          }
          v.currencySymbol = currencySymbol;
          v.name = settingMapFeeDetails[_.get(v, 'itemName')];
          v.value = _.round(_.toNumber(_.get(v, 'fee')), 2);
          v.averageFee = _.round(_.toNumber(_.get(v, 'averageFee')), 2)
          v.rate = _.round(_.get(v, 'feePercent'));
          return v;
        })
        this.initPercentageStoreExpensesPieTwoOption();
      }).complete(()=>{this.loading = false;})
    },
    initPercentageStoreExpensesOption(){
      let _this = this
      const option = {
        legend: {
          top: '0%',
          itemGap: 10,
          icon: "rect",
          itemWidth: 15,
          itemHeight: 3,
          textStyle: {
            color: '#888',
            padding: [2, 0, 0, 0],
          }
        },
        tooltip: {
            trigger: 'axis',
            formatter:function(params){
            let str = '';
            params.map((v,idx)=>{
              if(idx === 0 ){
                str += v.name + "<br/>";
              }
              if ([0, 1].includes(idx)) {
                str += v.marker + v.seriesName + ":&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + _this.currencySymbol + amount(v.value[idx + 1]) + "<br/>"
              }else {
                str += v.marker + v.seriesName + ":&nbsp;&nbsp;" + _this.currencySymbol + amount(v.value[idx + 1]) + "<br/>"
              }
            });
            return str;
          }
        },
        color: ['#73a0fa', '#73deb3', '#cdddfd'],
        dataset: {
          source: this.barSuourceData
        },
        xAxis: {
          type: 'category',
          axisLine: {
            show: false,
            lineStyle: {
              color: "#e5e9f2"
            }
          },
          axisLabel: {
            margin: 10,
            color: "#32393d"
          },
        },
        yAxis: {
          axisLabel: {
            margin: 10,
            color: "#32393d"
          },
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: "#e5e9f2"
            }
          },
        },
        series: [
          {type: 'bar', barMaxWidth : "30", barCateGoryGap:15},
          {type: 'bar', barMaxWidth : "30", barCateGoryGap:15},
          {type: 'bar', barMaxWidth : "30", barCateGoryGap:15}
        ]
      };
      this.percentageStoreExpensesOption = option;
    },
    initPercentageStoreExpensesPieOneOption(){
      const data = this.incomeItemsData;
      const option = {
        title: {
          text: '{header1| 费用项}' +
              '{header2| 平均费用}' +
              '{header3| 费用}' +
              '{header4| 费用占比}',
          // textAlign: 'left',
          left: '41%',
          top: '0%',
          right: "0%",
          textStyle: {
            // color: '#ccc',
            rich: {
              header1: {
                width: 90,
                fontSize: 14
              },
              header2: {
                width: 85,
                fontSize: 14
              },
              header3: {
                width: 90,
                fontSize: 14
              },
              header4: {
                fontSize: 14
              }
            }
          }
        },
        tooltip: {
          formatter:function(params){
            let str = '金额' + "<br/>";
            str += params.marker + params.data.name + ":&nbsp;&nbsp;" + params.data.currencySymbol + amount(params.data.fee)
            return str;
          }
        },
        legend: {
          // selectedMode: false, // 取消图例上的点击事件
          type: 'plain',
          icon: 'circle',
          orient: 'vertical',
          left: '40%',
          top: '10%',
          right: "0%",
          align: 'left',
          itemGap: 15,
          itemWidth: 10, // 设置宽度
          itemHeight: 10, // 设置高度
          symbolKeepAspect: false,
          tooltip:{
            show: true,
            formatter: (params) => {
              let name = _.get(params,"name", _.get(params, 'extraName'));
              let tooltipStr = "";
              switch (name) {
                case "销售额":
                  tooltipStr = "商品售价*销量";
                  break;
                case "平台费":
                  tooltipStr = "包括礼品包装费、 礼品包装税费、其他相关费用";
                  break;
                case "运费":
                  tooltipStr = "买家支付的运费";
                  break;
                case "退货补回成本":
                  tooltipStr = "货量*（采购成本+到库成本）+其他退<br/>货所产生的费用";
                  break;
                case "广告销售额":
                  tooltipStr = "由商品广告、展示广告产生的销售额，<br/>仅做展示，不参与计算";
                  break;
              }
              return tooltipStr;
            }
          },
          textStyle: {
            width: "100%",
            color: '#000',
            rich: {
              name: {
                verticalAlign: 'right',
                align: 'left',
                width: 90,
                fontSize: 12
              },
              topFloor:{
                borderTopColor: "#999",
                borderTopWidth: "1px",
                color: 'transparent',
              },
              extraName:{
                verticalAlign: 'right',
                align: 'left',
                width: 168,
                fontSize: 12
              },
              value: {
                align: 'left',
                width: 60,
                fontSize: 12
              },
              count: {
                align: 'left',
                width: 93,
                fontSize: 12
              },
              upRate: {
                align: 'left',
                fontSize: 12,
                width: 50,
                color: '#00cf90'
              },
              downRate: {
                align: 'left',
                fontSize: 12,
                width: "100%",
                color: '#ff5722'
              }
            }
          },
          grid: {
            left: "0%",
            right: "0%"
          },
          // data: data.map(item => item.name),
          data: data.map(item => {
            if(item.name === '分隔线'){
              item.icon = "none";
            }
            return item;
          }),
          formatter: function(name) {
            let className = 'upRate'
            let rateIcon = '▲'
            if (data && data.length) {
              for (var i = 0; i < data.length + 1; i++) {
                if (name === data[i].name) {
                  if (data[i].rate < 0) {
                    className = 'downRate'
                    rateIcon = '▼'
                  }
                  //如果是 Ads sales - 广告销售额, Discount cost - 促销折扣 做特殊处理
                  if(data[i].name === "广告销售额"){
                    className = 'adsSales';
                    return (
                        '{extraName| ' +
                        name + '}' +
                        data[i].currencySymbol + amount(data[i].fee)
                    )
                  } else {
                    return (
                        '{name| ' +
                        name +
                        '}   ' +
                        '{value| ' +
                        data[i].currencySymbol + amount(data[i].averageFee) +
                        '} ' +
                        '{count| ' +
                        data[i].currencySymbol + amount(data[i].fee) +
                        '} ' +
                        Math.abs(data[i].rate) +
                        '%'
                    )
                  }
                }
              }
            }
          }
        },
        rich:{
          discountCost: {
            borderTop: "1px solid #999",
          }
        },
        series: [{
          name: '数量',
          type: 'pie',
          radius: ['30%', '50%'],
          center: ['15%', '50%'],
          data: data,
          color: ["#1F6EEF","#F6BD14","#FB6E6C","#9E87FF","#999","#999","#999"],
          label: {
            normal: {
              show: false,
              position: 'center',
              formatter: '{text|{c}}\n{b}',
              rich: {
                text: {
                  align: 'center',
                  verticalAlign: 'middle',
                  padding: 8,
                  fontSize: 30
                },
                value: {
                  align: 'center',
                  verticalAlign: 'middle',
                  fontSize: 20
                }
              }
            },
            emphasis: {
              show: false,
              textStyle: {
                fontSize: '12'
              },
              formatter: '{text|{b}}\n{c}',
              rich:{
                text:{ fontSize: 14,lineHeight: 20},
              }
            }
          },

          labelLine: {
            normal: {
              show: true
            }
          }
        }]
      };
      this.percentageStoreExpensesPieOneOption = option;
    },
    initPercentageStoreExpensesPieTwoOption(){
      const data = this.expensesItemsData ? this.expensesItemsData : [{
        name: '数据1',
        value: 36,
        rate: 12
      },
        {
          name: '数据2',
          value: 20,
          rate: 20
        },
        {
          name: '数据3',
          value: 16,
          rate: -40
        },
        {
          name: '数据4',
          value: 10,
          rate: -15
        },
        {
          name: '数据5',
          value: 9,
          rate: 12
        },
        {
          name: '数据6',
          value: 9,
          rate: -6
        }
      ];
      const option = {
        title: {
          text: '{header1| 费用项}' +
              '{header2| 平均费用}' +
              '{header3| 费用}' +
              '{header4| 费用占比}',
          textAlign: 'left',
          left: '41%',
          top: '0%',
          textStyle: {
            // color: '#ccc',
            rich: {
              header1: {
                width: 90,
                fontSize: 14
              },
              header2: {
                width: 85,
                fontSize: 14
              },
              header3: {
                width: 90,
                fontSize: 14
              },
              header4: {
                fontSize: 14
              }
            }
          }
        },
        tooltip: {
          formatter:function(params){
            let str = '金额' + "<br/>";
            str += params.marker + params.data.name + ":&nbsp;&nbsp;" + params.data.currencySymbol + amount(params.data.fee)
            return str;
          }
        },
        legend: {
          // selectedMode: false, // 取消图例上的点击事件
          type: 'plain',
          icon: 'circle',
          orient: 'vertical',
          left: '40%',
          top: '10%',
          align: 'left',
          itemGap: 15,
          itemWidth: 10, // 设置宽度
          itemHeight: 10, // 设置高度
          symbolKeepAspect: false,
          textStyle: {
            color: '#000',
            rich: {
              name: {
                verticalAlign: 'right',
                align: 'left',
                width: 90,
                fontSize: 12
              },
              value: {
                align: 'left',
                width: 60,
                fontSize: 12
              },
              count: {
                align: 'left',
                width: 93,
                fontSize: 12
              },
              upRate: {
                align: 'left',
                width:50,
                fontSize: 12,
                color: '#00cf90'
              },
              downRate: {
                align: 'left',
                fontSize: 12,
                color: '#ff5722'
              }
            }
          },
          tooltip:{
            show: true,
            formatter: (params) => {
              let name = params.name;
              let tooltipStr = "";
              switch (name) {
                case "采购成本":
                  tooltipStr = "销售订单中所产生的采购成本，<br/>不包含多渠道订单采购成本";
                  break;
                case "到库成本":
                  tooltipStr = "销售订单中所产生的到库成本，<br/>不包含多渠道订单到库成本";
                  break;
                case "FBA配送费":
                  tooltipStr = "销售订单中FBA配送费";
                  break;
                case "销售佣金":
                  tooltipStr = "销售订单中销售佣金";
                  break;
                case "退款":
                  tooltipStr = "产生退款的订单中退还给买家的金额";
                  break;
                case "广告花费":
                  tooltipStr = "广告所产生的费用，<br/>包含商品广告、展示广告费用";
                  break;
                case "多渠道扣费":
                  tooltipStr = "多渠道订单所产生的费用包括采购成本、<br/>到库成本、其他费用";
                  break;
                case "推广订单费用":
                  tooltipStr = "标记为推广订单的订单所产<br/>生的推广本金与推广佣金";
                  break;
                case "促销折扣":
                  tooltipStr = "促销折扣金额";
                  break;
                case "其它":
                  tooltipStr = "其他销售相关费用";
                  break;
                case "仓储费":
                  tooltipStr = "包含FBA月仓储费、<br/>FBA 长期仓储费";
                  break;
              }
              return tooltipStr;
            }
          },
          grid: {
            left: "0%",
            right: "0%"
          },
          data: data.map(item => item.name),
          formatter: function(name) {
            let className = 'upRate'
            let rateIcon = '▲'
            if (data && data.length) {
              for (var i = 0; i < data.length; i++) {
                if (name === data[i].name) {
                  if (data[i].rate < 0) {
                    className = 'downRate'
                    rateIcon = '▼'
                  }
                  return (
                      '{name| ' +
                      name +
                      '}   ' +
                      '{value| ' +
                      data[i].currencySymbol + amount(data[i].averageFee) +
                      '} ' +
                      '{count| ' +
                      data[i].currencySymbol + amount(data[i].fee) +
                      '} ' +
                      Math.abs(data[i].rate) +
                      '%'
                  )
                }
              }
            }
          }
        },
        series: [{
          name: '数量',
          type: 'pie',
          radius: ['30%', '50%'],
          center: ['15%', '50%'],
          data: data,
          color: ["#1F6EEF","#F6BD14","#FB6E6C","#9E87FF","#51D351","#F25AA0","#6060FC","#63E6C4","#A9FF74","#F7D857",
            "#A15DE6","#FF8D7D","#F5CF62","#82FA77","#6BDBFF","#59B2FF","#C340F5","#3CE658","#FA8955","#0FE7FA"],
          label: {
            normal: {
              show: false,
              position: 'center',
              formatter: '{text|{c}}\n{b}',
              rich: {
                text: {
                  align: 'center',
                  verticalAlign: 'middle',
                  padding: 8,
                  fontSize: 30
                },
                value: {
                  align: 'center',
                  verticalAlign: 'middle',
                  fontSize: 20
                }
              }
            },
            emphasis: {
              show: false,
              textStyle: {
                fontSize: 14
              },
              formatter: '{text|{b}}\n{c}',
              rich:{
                text:{ fontSize: 14,lineHeight: 20},
              }
            }
          },
          labelLine: {
            normal: {
              show: true
            }
          }
        }]
      };

      this.percentageStoreExpensesPieTwoOption = option;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common/index.scss";
.percentage-store-expenses {
  margin-top: 10px;
}
.el-row {
  margin-bottom: 20px;
}
/deep/ .el-alert{
  align-items: center;
}
</style>
